import { DateRange } from '@mui/lab/DateRangePicker'
import { add, format } from 'date-fns'
import { isEqual } from 'lodash-es'
import { MM_DD_YYYY, YYYY_MM_DD } from 'utility/timeFormats'
import { IDateQuickFilterLabel } from './types'

export enum DateQuickFilters {
  ALL_TIME,
  TODAY,
  LAST_3_DAYS,
  LAST_7_DAYS,
  LAST_14_DAYS,
  LAST_MONTH,
  LAST_3_MONTHS,
  DEFINED
}

export const DATE_QUICK_FILTERS_LABELS: IDateQuickFilterLabel[] = [
  { label: 'All time', value: DateQuickFilters.ALL_TIME },
  { label: 'Today', value: DateQuickFilters.TODAY },
  { label: 'Last 3 days', value: DateQuickFilters.LAST_3_DAYS },
  { label: 'Last 7 days', value: DateQuickFilters.LAST_7_DAYS },
  { label: 'Last 14 days', value: DateQuickFilters.LAST_14_DAYS },
  { label: 'Last month', value: DateQuickFilters.LAST_MONTH },
  { label: 'Last 3 months', value: DateQuickFilters.LAST_3_MONTHS }
]

const DAYS_TO_SUBTRACT = {
  [DateQuickFilters.TODAY]: { days: 0 },
  [DateQuickFilters.LAST_3_DAYS]: { days: -3 },
  [DateQuickFilters.LAST_7_DAYS]: { days: -6 },
  [DateQuickFilters.LAST_14_DAYS]: { days: -13 },
  [DateQuickFilters.LAST_MONTH]: { days: -29 },
  [DateQuickFilters.LAST_3_MONTHS]: { days: -89 },
  // not using keys below, just to prevent TS errors for function - getFormattedDate
  [DateQuickFilters.ALL_TIME]: {},
  [DateQuickFilters.DEFINED]: {}
}

const getFormattedDate = (dateQuickFilter: DateQuickFilters) =>
  format(add(new Date(), DAYS_TO_SUBTRACT[dateQuickFilter]), YYYY_MM_DD)

export const getDateRange = (type: DateQuickFilters, dates?: Date[]) => {
  let startDate = getFormattedDate(type)
  let endDate = format(new Date(), YYYY_MM_DD)

  if (type === DateQuickFilters.DEFINED && dates) {
    startDate = format(dates[0], YYYY_MM_DD)
    endDate = format(dates[1] || dates[0], YYYY_MM_DD)
  }

  return { startDate, endDate }
}

export const getFormattedCustomRange = ([from, to]: DateRange<Date>) => {
  if (!from || !to) return

  let customOption = ''

  if (isEqual(from, to)) {
    customOption = format(from, MM_DD_YYYY)
  } else {
    customOption = `${format(from, MM_DD_YYYY)} - ${format(to, MM_DD_YYYY)}`
  }

  return customOption
}

export const parseDateParam = (dateString: string) => {
  const timestamp = Date.parse(dateString)

  if (isNaN(timestamp)) return new Date()

  const date = new Date(timestamp)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}
